import type { BillingInterval } from '@/services/api/billing/useGetBillingSubscription'

export function formatMoney(cents: number, currency: string): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(cents / 100)
}

export function formatBillingDate(date: string | null | undefined): string {
  if (!date) return '—'
  return new Date(date).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

export const INTERVAL_LABEL: Record<BillingInterval, string> = {
  month: 'month',
  year: 'year',
}

export const INTERVAL_ADJECTIVE: Record<BillingInterval, string> = {
  month: 'Monthly',
  year: 'Annual',
}

/** Whole-percent saving of paying annually vs 12 × monthly. */
export function annualSavingPercent(
  monthly?: number,
  annual?: number,
): number | null {
  if (!monthly || !annual) return null
  const saving = Math.round((1 - annual / (monthly * 12)) * 100)
  return saving > 0 ? saving : null
}

/**
 * httpClient's interceptor already toasts any HTTP error response; only
 * network-level failures (no response) still need a message of our own.
 */
export function wasToastedByInterceptor(error: unknown): boolean {
  return !!(error as { response?: unknown })?.response
}
